import { PERSONAL_INFO  } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(PERSONAL_INFO)
